import {
  ListItem,
  OrderedList,
  Stack,
  Text,
  UnorderedList,
} from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { AidInline, parseAidText } from '../aidText'

interface Props {
  text: string
}

// An aid's text, from its reduced markdown (#136)
export default function MeetingStepAidText({ text }: Props) {
  const blocks = useMemo(() => parseAidText(text), [text])

  const inline = (parts: AidInline[]) =>
    parts.map((part, index) =>
      part.bold ? (
        <Text as="strong" key={index}>
          {part.text}
        </Text>
      ) : (
        <React.Fragment key={index}>{part.text}</React.Fragment>
      )
    )

  return (
    <Stack spacing={2} fontSize="sm">
      {blocks.map((block, index) => {
        if (block.type === 'paragraph') {
          return <Text key={index}>{inline(block.inline)}</Text>
        }
        const List = block.type === 'numbers' ? OrderedList : UnorderedList
        return (
          <List key={index} spacing={1} pl={1}>
            {block.items.map((item, itemIndex) => (
              <ListItem key={itemIndex}>{inline(item)}</ListItem>
            ))}
          </List>
        )
      })}
    </Stack>
  )
}
